/* eslint-disable max-len */
import Helpers from '../Helpers'
import types from '../types'
import {signOut} from './signOut'

export const getGraphs = (database) => (dispatch, getState) => {
  const userReducer = getState().userReducer
  const url = userReducer.vkgDomain
  const authForm = userReducer.authForm
  const userId = userReducer.userId
  const authKey = authForm.authKey
  const orgId = authForm.orgId
  const licenseKey = authForm.licenseKey
  if (!url) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        nodes: {},
        isLoading: false,
        userMessage: 'Your organization doesn\'t have VKG access.',
        notificationType: 2,
        notificationIcon: 'check',
        isNotificationVisible: true,
      },
    })
  } else if (!(userReducer.userData?.permissions?.readVKG || userReducer.userData?.vkgAccess?.vkgs?.includes('read'))) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: false,
        userMessage: 'Your don\'t have read VKG access.',
        notificationType: 2,
        notificationIcon: 'warning',
        isNotificationVisible: true,
      },
    })
  } else {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: true,
      },
    })
    const endpoint = url + '/api/vkgs'
    const headers = {'userId': userId, 'authKey': authKey, 'orgId': orgId}
    if (licenseKey) {
      headers['Authorization'] = `Bearer ${licenseKey}`
    }
    Helpers.fetchGetJson(endpoint, headers, {})
        .then((res) => {
          if (!userReducer.userMessage && res.status !== 'SUCCESS') {
            dispatch({
              type: types.STORE_PAYLOAD,
              payload: {
                // eslint-disable-next-line max-len
                graphList: [],
                isLoading: false,
                userMessage: `Error: ${res?.error?.message || res.message}`,
                notificationType: 2,
                notificationIcon: 'warning',
                isNotificationVisible: true,
                isSignedIn: false,
              },
            })
            dispatch(signOut(false))
          } else {
            dispatch({
              type: types.STORE_PAYLOAD,
              payload: {
                // eslint-disable-next-line max-len
                graphList: res.vkgs,
                isLoading: false,
              },
            })
          }
        })
        .catch((error) => {
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              // eslint-disable-next-line max-len
              graphList: [],
              isLoading: false,
              userMessage: 'Failed to load in all graphs.',
              notificationType: 2,
              notificationIcon: 'warning',
              isNotificationVisible: true,
            },
          })
        })
  }
}
